import { SetMenuAction } from './../../../../store/common/common.actions';
import { mainLayout_Expanded } from './selectors';
import { MenuModel } from './../../../../model/menu.model';
import { AppState } from 'src/app/store/app.states';
import { Component, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ComponentBase } from 'src/app/views/component-base';
import {
  commomState_ElevatedAccess,
  commomState_IsLoading,
  commomState_LoggedinInfo,
  commomState_MenuList,
  commonState_IsFetching,
  commonState_MemberData,
  commonState_SystemConfig_AccountFeatureToggles,
} from 'src/app/store/common/common.selectors';
import { MainExpandedRequestAction } from './actions';
import { VerveState } from '../../store/verve.states';
import {
  MatDrawer,
  MatDrawerContainer,
  MatDrawerContent,
  MatDrawerMode,
  MatSidenavModule,
} from '@angular/material/sidenav';
import { insuranceQuestionnaire_ShowQuestionnaire } from 'src/app/modules/shared/components/insurance-questionnaire/selectors';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FeatureToggleName } from 'src/app/model/feature-toggle-name.model';
import { memberAccountDropdown_SelectedAccount } from 'src/app/modules/shared/components/member-account-dropdown/selectors';
import { AccountFeatureToggle } from 'src/app/model/account-feature-toggles.model';
import { FeatureToggleHelper } from 'src/app/helper/featureToggleHelper';
import { FeatureToggleValue } from 'src/app/model/feature-toggle-value.model';
import { combineLatest } from 'rxjs';
import { AsyncPipe, NgFor, NgClass, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AppScrollUpComponent } from '@ifaa-components/ui-components';
import { MemberAccountDropdownComponent } from 'src/app/modules/shared/components/member-account-dropdown/member-account-dropdown.component';
import { UserTopDropdownComponent } from 'src/app/modules/shared/components/user-top-dropdown/user-top-dropdown.component';
import { ScreenWidthDirective } from 'src/app/modules/shared/directives/screen-width.directive';
import { FeatureTogglePipe } from 'src/app/modules/shared/pipes/featureToggle';
import { TenantConfigPipe } from 'src/app/modules/shared/pipes/tenantconfig';
import { FooterComponent } from '../footer/footer.master';
import { AuthHelperService } from 'src/app/services/authHelper.service';

@Component({
  selector: 'login-master',
  templateUrl: './main.master.html',
  styleUrls: ['./main.master.scss'],
  imports: [
    ScreenWidthDirective,
    MatDrawerContainer,
    MatDrawer,
    MatSidenavModule,
    TenantConfigPipe,
    AsyncPipe,
    RouterLink,
    NgFor,
    NgClass,
    FeatureTogglePipe,
    NgIf,
    MatIcon,
    MatDrawerContent,
    MemberAccountDropdownComponent,
    UserTopDropdownComponent,
    AppScrollUpComponent,
    RouterOutlet,
    MatProgressSpinner,
    FooterComponent,
  ],
})
export class MainMasterComponent extends ComponentBase {
  expanded: MenuModel[] = [];
  expanded$ = this.vervestore.pipe(select(mainLayout_Expanded));
  menuList$ = this.store.pipe(select(commomState_MenuList));
  loggedInUser$ = this.store.pipe(select(commomState_LoggedinInfo));
  isLoading$ = this.store.pipe(select(commomState_IsLoading));
  isFetching$ = this.store.pipe(select(commonState_IsFetching));
  isQuestionnarieVisible$ = this.store.pipe(
    select(insuranceQuestionnaire_ShowQuestionnaire)
  );
  user$ = this.store.pipe(select(commonState_MemberData));

  selectedAccount$ = this.store.pipe(
    select(memberAccountDropdown_SelectedAccount)
  );
  accountFeatureToggles$ = this.store.pipe(
    select(commonState_SystemConfig_AccountFeatureToggles)
  );
  elevatedAccess$ = this.store.pipe(
    select(commomState_ElevatedAccess)
  );

  accountFeatureToggles: AccountFeatureToggle[] = null;
  featureToggleValues: any = null;
  featureToggleHelper = new FeatureToggleHelper();

  menuMode:MatDrawerMode = 'side';
  menuOpened = true;
  showMenuIconTop = true;
  menu = [
    {
      id: '1',
      name: 'Overview',
      link: '/dashboard',
      icon: 'house',
      children: [],
    } as MenuModel,
    {
      id: '2',
      name: 'Account',
      icon: 'account_box',
      children: [
        {
          id: '5-1',
          name: 'Update your details',
          link: '/personal-details',
          icon: 'create',
          children: [],
          featureFlag: FeatureToggleName.member.personalDetails.view,
        } as MenuModel,
        {
          id: '5-4',
          name: 'Change your password',
          link: '/change-password',
          icon: 'security',
          children: [],
          featureFlag: FeatureToggleName.member.changePassword.view,
        } as MenuModel,
        {
          id: '5-5',
          name: 'Take me with you',
          link: '/take-me-with-you',
          icon: 'tour',
          children: [],
          featureFlag: FeatureToggleName.member.account.takeMeWithYou.view,
        } as MenuModel,
      ],
    } as MenuModel,
    {
      id: '3',
      name: 'Investments',
      icon: 'attach_money',
      children: [
        {
          id: '3-1',
          name: 'Transaction History',
          link: '/transaction-listing',
          icon: 'receipt_long',
          children: [],
          featureFlag: FeatureToggleName.member.account.transactions.view,
        } as MenuModel,
        {
          id: '3-2',
          name: 'Manage Investments',
          link: '/investment',
          icon: 'currency_exchange',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.manageInvestments.update,
        } as MenuModel,
        {
          id: '3-3',
          name: 'Investment Switch History',
          link: '/investment/switch-history',
          icon: 'manage_history',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.manageInvestments.update,
        } as MenuModel,
        {
          id: '2-4',
          name: 'Underlying investment',
          link: '/' + environment.underlyingInvestment,
          icon: 'request_quote',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.underlyingInvestmentSummary.view,
        } as MenuModel,
      ],
    } as MenuModel,
    {
      id: '4',
      name: 'Consolidate',
      link: '/rollin',
      icon: 'account_balance_wallet',
      children: [],
      featureFlag: FeatureToggleName.member.account.rollIn.view,
    } as MenuModel,
    {
      id: '11',
      name: 'Contributions',
      icon: 'paid',
      children: [
        {
          id: '2-4',
          name: 'Make a contribution',
          link: '/make-a-contribution',
          icon: 'note_add',
          children: [],
          featureFlag: FeatureToggleName.member.account.makeAContribution.view,
        } as MenuModel,
        {
          id: '2-3',
          name: 'Make a personal contribution',
          link: '/personal-contributions',
          icon: 'local_atm',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.personalContribution.view,
        } as MenuModel,
        {
          id: '2-5',
          name: 'Notice of intent to claim a tax deduction',
          link: '/claim-a-tax-deduction',
          icon: 'price_change',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.intentToClaimTaxDeduction.view,
        } as MenuModel,
        {
          id: '2-2',
          name: 'Contribution Caps',
          link: '/contributions',
          icon: 'airplay',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.contributionCapLimits.view,
        } as MenuModel,
      ],
    } as MenuModel,
    {
      id: '6',
      name: 'Insurance',
      link: '/insurance',
      icon: 'verified_user',
      children: [
        {
          id: '6-1',
          name: 'Your insurance cover',
          link: '/insurance',
          fragment: 'insurance_details',
          icon: 'admin_panel_settings',
          children: [],
          featureFlag: FeatureToggleName.member.account.insuranceDetails.view,
        } as MenuModel,
        {
          id: '6-2',
          name: 'Request Insurance',
          link: '/insurance',
          fragment: 'insurance_questionnaire',
          icon: 'add_task',
          children: [],
          featureFlag:
            FeatureToggleName.member.account.insuranceQuestionnaire.view,
        } as MenuModel,
      ],
    } as MenuModel,
    {
      id: '12',
      name: 'Beneficiaries',
      link: '/beneficiaries',
      icon: 'supervisor_account',
      children: [],
      featureFlag: FeatureToggleName.member.account.beneficiaries.view,
    } as MenuModel,
    {
      id: '13',
      name: 'Access Your Super',
      link: '/access-your-super',
      icon: 'price_change',
      children: [],
      featureFlag: FeatureToggleName.member.account.accessYourSuper.view,
    } as MenuModel,
    {
      id: '7',
      name: 'Documents',
      icon: 'folder',
      children: [
        {
          id: '7-1',
          name: 'View Statements',
          link: '/member-statements',
          icon: 'text_snippet',
          children: [],
          featureFlag: FeatureToggleName.member.account.viewStatements.view,
        } as MenuModel,
        {
          id: '7-2',
          name: 'Other Documents',
          link: '/other-documents',
          icon: 'article',
          children: [],
          featureFlag: FeatureToggleName.member.account.otherDocuments.view,
        } as MenuModel,
      ],
    } as MenuModel,
    {
      id: '9',
      name: 'Verve Learn',
      icon: 'school',
      link: 'https://vervesuper.com.au/learn-members/',
      target: '_blank',
      children: [],
    } as MenuModel,
    {
      id: '10',
      name: 'Calculator',
      link: '/calculator',
      icon: 'calculate',
      children: [],
      featureFlag: FeatureToggleName.member.superCalculator.view,
    } as MenuModel,
  ];

  @ViewChild('drawer') drawer: MatDrawer;

  constructor(
    public store: Store<AppState>,
    public vervestore: Store<VerveState>,
    public dialog: MatDialog,
    private titleService: Title,
    private router: Router,
    private authHelperService: AuthHelperService
  ) {
    super();
    this.titleService.setTitle('Verve Super – Member Portal');
  }

  ngOnInit() {
    super.ngOnInitBase();
    // this.store.dispatch(RequestAction());

    this.sub = this.accountFeatureToggles$.subscribe(x => {
      if (x){
        this.accountFeatureToggles = x;
      }
    })

    this.featureToggleValues = {
      available: FeatureToggleValue.available,
      hidden: FeatureToggleValue.hidden,
      disabled: FeatureToggleValue.disabled,
    };

    this.screenWidthChange(this.store, (width: number) => {
      this.menuMode = 'side';
      this.menuOpened = true;

      if (width < 768) {
        this.menuMode = 'over';
        this.menuOpened = false;
      }
    });
    this.sub = this.expanded$.subscribe((x) => {
      this.expanded = x;
    });

    // Filter menu items based on insurance questionnaire and feature toggles, and then push to redux state
    combineLatest([
      this.selectedAccount$,
      this.accountFeatureToggles$,
      this.isQuestionnarieVisible$,
    ]).subscribe(([selectedAccount, featureToggles, isVisible]) => {
      if (
        selectedAccount &&
        featureToggles &&
        (isVisible === true || isVisible === false)
      ) {
        //Filter questionnaire stuff first
        var newMenu = [...this.menu];
        if (!isVisible) {
          for (let i = 0; i < newMenu.length; i++) {
            newMenu[i] = {
              ...newMenu[i],
              children: newMenu[i].children?.filter((c) => c.id != '6-2'),
            };
          }
        } else {
          for (let i = 0; i < newMenu.length; i++) {
            newMenu[i] = {
              ...newMenu[i],
              children: newMenu[i].children?.filter((c) => c.id != '6-1'),
            };
          }
        }

        // Filter feature toggles
        var returnMenu = [];
        for (let i = 0; i < newMenu.length; i++) {
          // If the menu item has children we should check that at least 1 child item will be available/disabled
          // If there are 0 child items available/disabled, we dont show the top level menu item
          if (newMenu[i].children.length > 0) {
            var topLevelMenuItem = {
              ...newMenu[i],
              children: newMenu[i].children?.filter((c) =>
                this.featureToggleHelper.checkToggle(
                  c.featureFlag,
                  featureToggles,
                  selectedAccount
                )
              ),
            };

            if (topLevelMenuItem.children.length > 0) {
              returnMenu.push(topLevelMenuItem);
            }
          } else {
            // If there are 0 children, we just check the feature toggle on the top level item and add it if its not hidden (e.g. AYS)
            if (
              this.featureToggleHelper.checkToggle(
                newMenu[i].featureFlag,
                featureToggles,
                selectedAccount
              )
            ) {
              returnMenu.push(newMenu[i]);
            }
          }
        }

        this.setMenu(returnMenu);
      }
    });
  }

  openedChange() {
    if (this.drawer) {
      this.menuOpened = this.drawer.opened;
    }
  }
  onSwipeToggle(event) {
    this.menuOpened = !this.menuOpened;
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onItemSelectedClick(item: MenuModel) {
    this.store.dispatch(MainExpandedRequestAction({ menuItem: item }));

    if (item.link?.startsWith('http')) {
      window.open(item.link, '_blank');
      return;
    }

    if (item.link) {
      this.router.navigate([item.link]);
    }
  }

  isMenuExpanded(item: MenuModel) {
    return this.expanded.filter((x) => x.id == item.id).length > 0;
  }

  async onSignoutClick() {
    await this.authHelperService.logoutRedirect();
  }

  setMenu(menu: MenuModel[]) {
    this.store.dispatch(SetMenuAction({ data: menu }));
  }
}
